import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
import { formatDate } from '../utils/dateParse';
import { TranslationKey } from '../types';

interface SummaryRowProps {
  label: string;
  value: React.ReactNode;
  formatting?: 'decimal' | 'currency' | 'boolean' | 'date' | 'uppercase';
}

const SummaryRow: React.FC<SummaryRowProps> = ({
  label,
  value,
  formatting,
}) => {
  let formattedValue = null;

  const t = (title: TranslationKey) => {
    return window.translator.t(
      [`dossierlabel_${title}`, `vraaggroep_${title}`, title],
      title
    );
  };

  if (value === null || value === undefined || value === '' || value === 0) {
    return null;
  }

  if (formatting) {
    switch (formatting) {
      case 'decimal':
        formattedValue = (
          <NumericFormat
            thousandSeparator={'.'}
            displayType={'text'}
            valueIsNumericString={true}
            decimalSeparator={','}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle={'thousand'}
            value={value as string | number}
          />
        );
        break;
      case 'currency':
        formattedValue = (
          <NumericFormat
            thousandSeparator={'.'}
            displayType={'text'}
            valueIsNumericString={true}
            decimalSeparator={','}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle={'thousand'}
            prefix={'€ '}
            value={value as string | number}
          />
        );
        break;
      case 'boolean':
        formattedValue =
          value === 'true' || value === 'ja' ? t('ja') : t('nee');
        break;
      case 'date':
        if (typeof value === 'string') {
          formattedValue = formatDate(value, true);
        } else {
          formattedValue = '';
        }
        break;
      case 'uppercase':
        formattedValue = String(value).toUpperCase();
    }
  }

  return (
    <Row className="mb-2">
      <Col xs={12} sm={4}>
        <span className="text-label">{label}</span>
      </Col>
      <Col xs={12} sm={8}>
        <span className="text-muted" id={label}>
          {formatting ? formattedValue : value}
        </span>
      </Col>
    </Row>
  );
};

export default SummaryRow;
